import { styled, css } from 'styled-components'
import { COLORS } from 'tokens'

export const ShopItemsList = styled.div`
  width: calc(100% - 40px);
  margin: 0 20px 8px;
  padding: 12px;
  border: 1px solid ${COLORS.borderPrimary};
  border-radius: 8px;
  background: var(--color-bg);
  display: grid;
  grid-template-columns: repeat(2, 263px);
  gap: 10px;
`

export const ShopItemRow = styled('button')<{ $blocked?: boolean }>`
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr) auto 24px;
  align-items: center;
  gap: 10px;
  width: 263px;
  height: 48px;
  padding: 8px 8px 8px 12px;
  box-sizing: border-box;
  border: none;
  border-radius: 6px;
  background: var(--color-bg);
  box-shadow: var(--shadow-box);
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: inherit;

  ${({ $blocked }) =>
    $blocked &&
    css`
      cursor: not-allowed;
      opacity: 0.45;
    `}
`

export const ShopItemSpacer = styled.div`
  width: 263px;
  height: 48px;
  visibility: hidden;
  pointer-events: none;
`

export const ProductThumb = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 4px;
  object-fit: cover;
  flex-shrink: 0;
`

export const ProductThumbPlaceholder = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 4px;
  background: #f3f3f3;
  flex-shrink: 0;
`

export const ProductName = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: var(--color-text-primary);
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ProductQty = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: var(--color-text-primary);
  flex-shrink: 0;
  min-width: 12px;
  text-align: right;
  margin-right: 10px;
`

export const CheckIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
`
